import { api } from "./api";
import { Avatar, usePoll } from "./ui";

const MEDAL = ["🥇", "🥈", "🥉"];

export function Leaderboard({ gameId, highlightId }: { gameId: string; highlightId?: string }) {
  const { data } = usePoll(() => api.leaderboard(gameId), 3000, [gameId]);
  const entries = data?.entries ?? [];

  return (
    <div className="bg-white rounded-2xl border border-black/5 shadow-sm p-4">
      <h2 className="font-display font-bold mb-3">🏆 Leaderboard</h2>
      <ul className="space-y-1.5">
        {entries.map((e, i) => (
          <li
            key={e.playerId}
            className={
              "flex items-center gap-3 rounded-xl px-3 py-2 " +
              (e.playerId === highlightId ? "bg-wa/10" : "")
            }
          >
            <span className="w-6 text-center text-sm">{MEDAL[i] ?? i + 1}</span>
            <Avatar color={e.color} size={28} />
            <span className="flex-1 text-sm truncate">{e.name}</span>
            <span className="text-sm font-semibold tabular-nums">{e.correct}</span>
          </li>
        ))}
        {entries.length === 0 && <li className="text-sm text-ink/40">No scores yet.</li>}
      </ul>
    </div>
  );
}
